import { isNullOrUndefined, raise } from '@vy/utils';
import { createContext, useContext } from 'react';
import type { UseVyStepper } from '../../hooks/use-vy-stepper';
import type { PlanInputForm } from '../../pages/plans/CreatePlanPage/create-plan-page-components/CreatePlanForm/create-plan-form-types/plan-input-form';
import type { CreatePlanTab } from '../../pages/plans/CreatePlanPage/create-plan-page-components/CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import type { PlanCreationStep } from './create-plan-context-types/plan-creation-step';
import type { PlanCreationPlanPreview } from './CreatePlanProvider/create-plan-provider-types/plan-creation-plan-preview';
import { PlanCreateReason } from './create-plan-context-types/plan-create-reason';

export type CreatePlanContextProps<ExistingPlan extends PlanInputForm> = {
  createPlanTab: CreatePlanTab;
  setCreatePlanTab: (tab: CreatePlanTab) => void;
  planCreationReason: PlanCreateReason;
  existingPlan?: ExistingPlan;
  planPreview: PlanCreationPlanPreview;
  planCreationStepper: UseVyStepper<PlanCreationStep>;
  onFormSubmission?: (planInput: ExistingPlan) => Promise<void>;
  isCloningPlan?: boolean;
};

export const CreatePlanContext = createContext<CreatePlanContextProps<any> | undefined>(undefined);

export function useCreatePlanContext<ExistingPlan extends PlanInputForm>() {
  const createPlanContext = useContext<CreatePlanContextProps<ExistingPlan> | undefined>(CreatePlanContext);

  if (isNullOrUndefined(createPlanContext)) {
    raise('useCreatePlanContext must be used within a CreatePlanContextProvider');
  }

  return createPlanContext;
}
